import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TransferableSubscriptionsComponent } from './transferable-subscriptions.component';

const routes: Routes = [
  { path: '', component: TransferableSubscriptionsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TransferableSubscriptionsRoutingModule {}
